import { createFeature, createReducer, createSelector, on } from '@ngrx/store';
import { UserActions } from './user.actions';
import { UserModels } from '@share-models';

export interface UserState {
  profile: UserModels.UserDocument | null;
}

const initialState: UserState = {
  profile: null,
};

export const userStateReducer = createReducer(
  initialState,
  on(UserActions.resetToInitialState, () => {
    return {
      ...initialState,
    };
  }),
  on(UserActions.getUserProfileSuccess, (state, { profile }) => {
    return {
      ...state,
      profile,
    };
  }),
);

export const userFeature = createFeature({
  name: 'user',
  reducer: userStateReducer,
  extraSelectors: ({ selectUserState }) => ({
    selectIsDeveloper: createSelector(
      selectUserState,
      (state) =>
        state.profile?.roles?.includes(UserModels.Role.DEVELOPER) ?? false,
    ),
  }),
});
